export default __webpack_public_path__ + "a881dbf49f9601b45a5c09586fab08b1.coffee";